import React, { Component } from 'react'

import './_backButton.css'

class BackButton extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  }

  static defaultProps = {
    title: 'Кнопка',
  }

  render() {
    const { title } = this.props

    return(
      <button className="back-button iconic" onClick={this.context.router.goBack}>
        <span>{title}</span>
      </button>
    )
  }
}

export default BackButton


// WEBPACK FOOTER //
// ./src/components/back-button/BackButton.js